import React from 'react';

const SetupTitleDesc = (props) => {
    return (
        <div style={{ fontWeight: 400, fontSize: 14, color: '#605E5C' }}>
            {props?.children}
        </div>
    );
}

export default SetupTitleDesc;